import { Button, withStyles } from '@material-ui/core';
import { OrganizationProfile as OrganizationProfileWeb, NewUiWrapper } from '@tuqqi/web';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { store } from '../../../..';
import { initSubscriptionModal, openSubscriptionModal } from '../../../../actions/upgradeSubscriptionActions';

const styles = theme => ({
    wrap: {

    },
    patches: {
        position: 'absolute',
        bottom: 10,
        marginLeft: 270,
        maxWidth: 'calc(100vw - 270px)'
    }
});

const allowedPatches = ["localhost:3000", "newui.tuqqi.com", "test.tuqqi.com"]
const OrganizationProfileView = (props) => {
    const {dispatch} = props
    const openSubscriptionDialog = (reason) => {
        if(!reason) return
        dispatch(initSubscriptionModal({reason, mode: 'existed'}))
        dispatch(openSubscriptionModal())
    }

    const callbacks = {
        onShowSubscriptionModal: openSubscriptionDialog,
    }
    
    const applyPatch = (uid) => {
        props.adminService.applyPatch(uid).then(() => {
          
        });
      };


    const renderPatches = () => {
        if(!allowedPatches.includes(window.location.host)) return null


        return <div className={props.classes.patches}>
            <Button onClick={()=>{applyPatch("fixDataType")}}>
                {'fix data type'}
            </Button>
            <Button onClick={()=>{applyPatch("newReportView")}}>
                {'Apply patch 7.3.0'}
            </Button>
            <Button onClick={()=>{applyPatch("fixTableView")}}>
                {'Fix table view'}
            </Button>
            <Button onClick={()=>{applyPatch("fixTableView2")}}>
                {'Fix table view2'}
            </Button>
            <Button onClick={()=>{applyPatch("fixRelated")}}>
                {'Fix related'}
            </Button>
            <Button onClick={()=>{applyPatch("fixCounter")}}>
                {'Fix counter'}
            </Button>
            <Button onClick={()=>{applyPatch("fixStatus")}}>
                {'Fix status'}
            </Button>
            <Button onClick={() => { applyPatch("fixWatchers") }}>
                {'fix watchers'}
            </Button>
        </div>
    }


    return <NewUiWrapper store={store} callbacks={callbacks}>
        {/* <div> */}
            {/* <div> */}
                <OrganizationProfileWeb />
            {/* </div> */}
            {renderPatches()}
        {/* </div> */}
    </NewUiWrapper>}

const mapStateToProps = (state) => ({
    adminService: state.services.adminService
})

const mapDispatchToProps = dispatch => {
    return { dispatch }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
))(OrganizationProfileView);
